<script lang="ts">
	import type { Snippet } from 'svelte';

	import { slide } from 'svelte/transition';

	let {
		class: className,
		name,
		selected,
		icon,
		children,
		onclick,
	}: {
		class?: string;
		name: string;
		selected?: Snippet;
		icon: Snippet;
		children?: Snippet;
		onclick: () => void;
	} = $props();
</script>

<div class={['group w-full snap-start', className]}>
	<div class="flex gap-1">
		<button
			{onclick}
			class="w-full cursor-pointer border-b border-b-neutral-300 px-1 py-1 transition-colors hover:bg-neutral-200"
		>
			<div class="flex items-center justify-between">
				<span class="font-semibold">
					{name}
				</span>
				{@render icon()}
			</div>

			{#if selected}
				<div transition:slide class="mt-1 text-left text-sm">
					{@render selected()}
				</div>
			{/if}
		</button>
	</div>
	<div>
		{@render children?.()}
	</div>
</div>
